import {
  ResourceService,
} from '@/internal';

export default class LogEntryItemService extends ResourceService {
  constructor() {
    super();
    this.baseUrl = 'log-entry-item';
  }
}
